/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: api地址配置文件
 * @Date: 2021-10-18 17:50:41
 * @LastEditTime: 2021-10-18 17:50:42
 */


export default {
  test:'/test'
}